export default __webpack_public_path__ + "static/banner-software-consulting-5ed44eb74f1b04de149c6a94a84b0290.jpg";